module.exports = __webpack_public_path__ + "img/more.45715283.png";